import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]

import {Trademark} from "@/endpoints/rutsolve/gql/generated/graphql"
  import {nextTick} from "vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'trademark',
  props: /*@__PURE__*/_mergeModels({
    items: {
      default: null,
      required: true,
      type: Array<Trademark>
    }
  }, {
    "selectedIndex": {
    default: null,
    required: false,
    type: Number
  },
    "selectedIndexModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["select"], ["update:selectedIndex"]),
  setup(__props, { emit: __emit }) {

  

  const emits = __emit

  const selectedIndex = _useModel(__props, "selectedIndex")

  async function select(index: number) {
    selectedIndex.value = index
    await nextTick()
    emits("select")
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      (__props.items)
        ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, " Name ")
              ])
            ], -1)),
            (__props.items.length > 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (trademark, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: trademark.id,
                      class: _normalizeClass({'selected' : selectedIndex.value == index}),
                      onClick: ($event: any) => (select(index))
                    }, [
                      _createElementVNode("td", null, _toDisplayString(trademark.name), 1)
                    ], 10, _hoisted_3))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})